// @core/api/endpoints/project/update_item.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ItemResponse,
  UpdateItemRequest,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Update project item
 * Updates project-specific item metadata such as story points, epic assignment, or custom fields. Does not modify the underlying source task.
 */
export async function UpdateItem(
  project_id: string,
  item_id: string,
  data: UpdateItemRequest,
  options?: RequestOptions
): Promise<ItemResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/items/:item_id`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  requestPath = requestPath.replace(':item_id', encodeURIComponent(item_id));
  const requestOptions = options;
  return client.put<ItemResponse>(requestPath, data, requestOptions);
}
